import { useState } from "react";
import { useRecordContext, Labeled, NumberField, SimpleShowLayout, Button } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { settings } from "app";
import FeesEditForm from "./FeesEditForm";

const FeesSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const record = useRecordContext();
  const [isEditing, setIsEditing] = useState(false);

  return (
    <SimpleShowLayout>
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        {isEditing ? (
          <FeesEditForm
            record={record}
            setIsEditing={setIsEditing}
          />
        ) : (
          <>
            <Grid
              item
              xs={12}
              md={6}
            >
              <Labeled label="Такса за обработка на документи">
                <NumberField source="fee.documentProcessingFee" />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              <Labeled label="Такса за дневно обучение">
                <NumberField source="fee.dailyTrainingFee" />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              <Labeled label="Такса за издаване на сертификат">
                <NumberField source="fee.certificateIssueFee" />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              <Labeled label="Такса за дубликат на сертификат">
                <NumberField source="fee.duplicateCertificateIssueFee" />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <SecuredComponent permission={permissions.canUpdateAdvancedSpecializationsFees}>
                <Button
                  variant="contained"
                  startIcon={<EditIcon />}
                  label="Редактирай"
                  onClick={() => setIsEditing(v => !v)}
                />
              </SecuredComponent>
            </Grid>
          </>
        )}
      </Grid>
    </SimpleShowLayout>
  );
};

export default FeesSection;
